import { atom } from 'recoil';

export { scoreAtom, pscoreAtom };

const scoreAtom = atom({
    key: {
        name: 'score'
    },
    default: []
});

const pscoreAtom = atom({
    key: {
        name: 'pscore'
    },
    default: {
        user_ref: {},
        scores: []
    }
});